// extracted by mini-css-extract-plugin
export default {"categoryListContainer":"ooRST","title":"_9zX8c"};